import React from "react";
import { connect } from "react-redux";

const Banner = ({ siteSurveyAlert, app, notSubmitedMessage, offineModeMessage  }) => {
  return app.internetStatus ? (
    siteSurveyAlert.displaySiteSurveyBanner && (
      <div className="site-survey-banner">
        <p className="banner-text site-survey-banner-c">
          {notSubmitedMessage}!
        </p>
      </div>
    )
  ) : (
    <div className="site-survey-banner">
      <p className="banner-text internet-info-banner">
        {offineModeMessage}.
      </p>
    </div>
  );
};

function mapStateToProps({ siteSurveyAlert, app, i18n }) {
  return { siteSurveyAlert, app, notSubmitedMessage: i18n.strings?.Common?.siteSurveyNotSubmited, offineModeMessage: i18n.strings?.Common?.offlineMode };
}

export const SiteSurveyBanner = connect(mapStateToProps, null)(Banner);
